import React, { useCallback, useEffect, useState } from "react";
import {
  Navigate,
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes
} from "react-router-dom";
import { CssBaseline } from "@mui/material";
import PrivateRoute from "./PrivateRoute";
import http from "./commonFunctions/httpClient";
import DashboardLayout from "./Components/Dashboard/DashboardLayout";
import config from "./Config/config.json";

import OrderList from "./Components/DataGrid/OrderList";
import Logout from "./FrontEnd/Logout/LogOut";
import { LoginForm } from "./FrontEnd/Login/Login";
import { OrderListUI } from "./FrontEnd/Orders/OrdersListUI";
import { FranchiseUser } from "./FrontEnd/Registration/User";
const SESSION_TIMEOUT = config.sessionTimeOut * 60 * 1000; // 15 minutes

const App: React.FC = () => {
  const [token, setToken] = useState<string | null>(
    localStorage.getItem("token")
  );
  // const [lastActivity, setLastActivity] = useState<number>(Date.now());

  useEffect(() => {
    if (token) {
      http.setAuthToken(token);
    }
  }, [token]);

  useEffect(() => {
    if (!token) return;

    // const handleActivity = () => {
    //   setLastActivity(Date.now());
    // };

    // // Add event listeners for user activity
    // window.addEventListener("mousemove", handleActivity);
    // window.addEventListener("keydown", handleActivity);

    // const checkTimeout = () => {
    //   if (Date.now() - lastActivity > SESSION_TIMEOUT) {
    //     handleLogout(); // Logout the user after inactivity
    //     window.location.reload();
    //   }
    // };

    // const intervalId = setInterval(checkTimeout, 1000); // Check for timeout every second

    // return () => {
    //   clearInterval(intervalId);
    //   window.removeEventListener("mousemove", handleActivity);
    //   window.removeEventListener("keydown", handleActivity);
    // };
  }, [token]);

  const handleLogin = (newToken: string) => {
    setToken(newToken);
    localStorage.setItem("token", newToken);
    http.setAuthToken(newToken);
  };

  const handleLogout = useCallback(() => {
    setToken(null);
    localStorage.removeItem("token");
    http.setAuthToken(null);
  }, []);

  return (
    <>
      <Router>
        <CssBaseline />
        <Routes>
          {/* Route for Login */}
         
          <Route path="/login" element={token !== null ? <Navigate to="/" /> : <LoginForm onLogin={handleLogin} />} />
          <Route path="/logout" element={<Logout />} />
           

          {/* Protect the routes with PrivateRoute for authentication */}
          <Route path="/" element={token ? <DashboardLayout /> : <Navigate to="/login" />}>
            <Route index element={token ? <OrderListUI /> : <Navigate to="/login" />} />
            <Route path="/*" element={token ? <PrivateRoute token={token} /> : <Navigate to="/login" />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
};

export default App;
